import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import ReactDOM from 'react-dom';

import {
  ComingSoonMarker,
  Marker,
  MinusIcon,
  PlusIcon,
  SoldMarker,
} from '../../admin/icons/index';

const InteractiveSitePlan = () => {
  const [siteMapImage, setSiteMapImage] = useState();
  const [plots, setPlots] = useState([]);
  const [showPlotInfo, setShowPlotInfo] = useState(false);
  const [plotInfo, setPlotInfo] = useState();
  const [zoom, setZoom] = useState(1);
  const [dragPageX, setMapPageX] = useState(0);
  const [dragPageY, setMapPageY] = useState(0);
  const [maxZoom, setMaxZoom] = useState(2.75);
  const [minZoom, setMinZoom] = useState(1);

  // Map Dragging State
  const [isMouseDown, setMouseDown] = useState(false);
  const [mouseX, setMouseX] = useState();
  const [mouseY, setMouseY] = useState();
  const [elementX, setElementX] = useState(0);
  const [elementY, setElementY] = useState(0);
  const [elementStyleX, setElementStyleX] = useState('0');
  const [elementStyleY, setElementStyleY] = useState('0');

  const baseAPIRoute = `/wp-json/api`;
  const markerActiveClass = 'interactive-site-plan__marker--active';

  const customACFText = document.querySelector('#interactive-site-plan')
    .attributes[3].value;

  useEffect(() => {
    // remove marker class active when showplot info is false...
    if (!showPlotInfo) {
      const plotActiveSelector = document.querySelectorAll(
        `.${markerActiveClass}`,
      );
      if (
        typeof plotActiveSelector !== undefined &&
        plotActiveSelector != null
      ) {
        plotActiveSelector.forEach((i) =>
          i.classList.remove(markerActiveClass),
        );
      }
    }
  }, [showPlotInfo]);

  useEffect(() => {
    changeZoomOnViewPortChange();
  }, []);

  const changeZoomOnViewPortChange = () => {
    const viewportWidth =
      window.innerWidth || document.documentElement.clientWidth;
    if (viewportWidth >= 1024) {
      setMaxZoom(2.75);
      setMinZoom(1);
      setZoom(1);
    } else {
      setMaxZoom(2);
      setMinZoom(0.55);
      setZoom(0.55);
    }
  };

  useEffect(async () => {
    const developmentId = document.querySelector('#interactive-site-plan')
      .attributes[1].value;
    const siteMapImageURL = document.querySelector('#interactive-site-plan')
      .attributes[2].value;

    const sitePlanPlots = await axios(
      `${baseAPIRoute}/development/plots?id=${developmentId}`,
    );
    const fetch = await axios(
      `${baseAPIRoute}/site-plan-plots?id=${developmentId}`,
    );

    if (sitePlanPlots?.data) {
      const allPlots = fetch.data.items;
      let newPlotsArr = [];

      sitePlanPlots.data.filter((item) =>
        allPlots.find((rm) => {
          if (item.id === rm.id) {
            newPlotsArr = [
              ...newPlotsArr,
              {
                ...rm,
                x: item.x,
                y: item.y,
              },
            ];
          }
        }),
      );

      setPlots(newPlotsArr);
    }

    setSiteMapImage(siteMapImageURL);
  }, []);

  const setActiveMarkerClass = (id) => {
    const markers = document.querySelectorAll('.interactive-site-plan__marker');
    markers.forEach((marker) => {
      if (marker.dataset.id == id) {
        marker.classList.toggle(markerActiveClass);
      }
    });
  };

  const handleMarkerClick = (plot) => {
    setPlotInfo(plot);
    setShowPlotInfo(false);

    setTimeout(() => {
      setShowPlotInfo(true);
      setActiveMarkerClass(plot.id);
    }, 250);
  };

  const onInfoWindowClose = (e) => {
    e.preventDefault();
    setShowPlotInfo(false);
  };

  const increaseZoom = (e) => {
    e.preventDefault();
    if (zoom <= maxZoom && zoom != maxZoom) {
      setZoom(zoom + 0.25);
    }
  };

  const decreaseZoom = (e) => {
    e.preventDefault();
    if (zoom >= minZoom && zoom != minZoom) {
      setZoom(zoom - 0.25);
    }
  };

  const isMaxZoom = !(zoom <= maxZoom && zoom != maxZoom);
  const isMinZoom = !(zoom >= minZoom && zoom != minZoom);

  const disabledClass =
    'interactive-site-plan__zoomButton interactive-site-plan__zoomButton--disabled';
  const defaultButtonClass = 'interactive-site-plan__zoomButton';

  const increaseZoomButtonClass =
    zoom <= maxZoom && zoom != maxZoom ? defaultButtonClass : disabledClass;
  const decreaseZoomButtonClass =
    zoom >= minZoom && zoom != minZoom ? defaultButtonClass : disabledClass;

  const returnStatusIcon = (status) => {
    if (status == 'coming-soon') {
      return <ComingSoonMarker />;
    }
    if (status == 'sold') {
      return <SoldMarker />;
    }
    return <Marker />;
  };

  const handleMapDragDown = (e) => {
    setMouseDown(true);
    const deviceClientX = e.clientX ? e.clientX : e.touches[0].clientX;
    const deviceClientY = e.clientY ? e.clientY : e.touches[0].clientY;
    setMouseX(deviceClientX);
    setMouseY(deviceClientY);
  };

  const handleMapDragUp = (e) => {
    setMouseDown(false);
    setElementX(parseInt(elementStyleX) || 0);
    setElementY(parseInt(elementStyleY) || 0);
  };

  const handleMapDragMouseMove = (e) => {
    const deviceClientX = e.clientX ? e.clientX : e.touches[0].clientX;
    const deviceClientY = e.clientY ? e.clientY : e.touches[0].clientY;
    if (!isMouseDown) return;
    const deltaX = deviceClientX - mouseX;
    const deltaY = deviceClientY - mouseY;
    setElementStyleX(elementX + deltaX);
    setElementStyleY(elementY + deltaY);
  };

  const handleSitePlanClick = useCallback(() => {
    const viewOnSitePlanBtn = document.querySelector('.button--siteplan');
    const { plotId } = viewOnSitePlanBtn.dataset;
    const currentPlotInfo = plots.find((plot) => plot.id == plotId);
    setPlotInfo(currentPlotInfo);
    setShowPlotInfo(false);
    setTimeout(() => {
      setShowPlotInfo(true);
      setActiveMarkerClass(plotId);
    }, 250);
  }, [plots]);

  useEffect(() => {
    const viewOnSitePlanBtn = document.querySelector('.button--siteplan');
    if (typeof viewOnSitePlanBtn !== 'undefined' && viewOnSitePlanBtn) {
      viewOnSitePlanBtn.addEventListener('click', handleSitePlanClick);
    }
    return () => {
      if (typeof viewOnSitePlanBtn !== 'undefined' && viewOnSitePlanBtn) {
        viewOnSitePlanBtn.removeEventListener('click', handleSitePlanClick);
      }
    };
  }, [handleSitePlanClick]);

  const handleOuterClick = (e) => {
    if (e.target.tagName !== 'circle') {
      setShowPlotInfo(false);
    }
  };

  const renderPlots = () =>
    plots.map(
      (plot, index) =>
        !plot.hide_on_site_plan && (
          <div
            className="interactive-site-plan__marker"
            data-id={plot.id}
            key={index}
            onClick={() => handleMarkerClick(plot)}
            style={{
              position: 'absolute',
              left: `${plot.x}px`,
              top: `${plot.y}px`,
              zIndex: '5',
              cursor: 'pointer',
            }}
          >
            {returnStatusIcon(plot.status)}{' '}
            <h2 className="interactive-site-plan__markerNumber">
              {plot.number}
            </h2>
          </div>
        ),
    );

  return (
    <div className="container">
      <div className="siteplan__top">
        <h3>Interactive Site Plan</h3>
        <p>{customACFText}</p>
      </div>

      <div className="interactive-site-plan" onClick={handleOuterClick}>
        <div className="interactive-site-plan__keys">
          <li className="interactive-site-plan__keys-item">
            {' '}
            <span className="interactive-site-plan__keys-color interactive-site-plan__keys-color--black" />{' '}
            Available
          </li>
          <li className="interactive-site-plan__keys-item">
            {' '}
            <span className="interactive-site-plan__keys-color interactive-site-plan__keys-color--grey" />{' '}
            Coming Soon
          </li>
          <li className="interactive-site-plan__keys-item">
            {' '}
            <span className="interactive-site-plan__keys-color interactive-site-plan__keys-color--pink" />{' '}
            Sold
          </li>
        </div>
        <div className="interactive-site-plan__zoom">
          <button
            className={increaseZoomButtonClass}
            onClick={increaseZoom}
            disabled={isMaxZoom}
          >
            <PlusIcon />
          </button>
          <button
            className={decreaseZoomButtonClass}
            onClick={decreaseZoom}
            disabled={isMinZoom}
          >
            <MinusIcon />
          </button>
        </div>

        <div
          className="interactive-site-plan__map"
          onMouseDown={handleMapDragDown}
          onMouseUp={handleMapDragUp}
          onMouseMove={handleMapDragMouseMove}
          onTouchStart={handleMapDragDown}
          onTouchEnd={handleMapDragUp}
          onTouchMove={handleMapDragMouseMove}
          id="map-image"
          onClick={handleOuterClick}
          style={{
            position: 'relative',
            transform: `scale(${zoom})`,
            backgroundImage: `url(${siteMapImage})`,
            top: `${elementStyleY}px`,
            left: `${elementStyleX}px`,
          }}
        >
          {plots && renderPlots()}
        </div>

        {showPlotInfo && (
          <div
            className={`interactive-site-plan__info ${
              showPlotInfo && 'interactive-site-plan__info--active'
            }`}
          >
            {plotInfo?.image && (
              <img src={plotInfo.image} className="plot-card__image" />
            )}
            <div className="plot-card__details plot-card__details--padding">
              <div className="plot-card__header">
                {plotInfo?.title && (
                  <h2 className="plot-card__title"> {plotInfo.title} </h2>
                )}
                {plotInfo?.number && (
                  <h3 className="plot-card__number">No. {plotInfo.number}</h3>
                )}
              </div>
              {plotInfo?.offers_over_price && plotInfo?.status != 'sold' && (
                <h4 className="plot-card__price">
                  {plotInfo.offers_over_text}{' '}
                  {new Intl.NumberFormat('en-GB', {
                    currency: 'GBP',
                    style: 'currency',
                    minimumFractionDigits: 0,
                  }).format(plotInfo.offers_over_price)}
                </h4>
              )}
              {plotInfo?.price &&
                plotInfo?.status != 'sold' &&
                plotInfo?.offers_over_price.length === 0 && (
                  <h4 className="plot-card__price">
                    {new Intl.NumberFormat('en-GB', {
                      currency: 'GBP',
                      style: 'currency',
                      minimumFractionDigits: 0,
                    }).format(plotInfo.price)}{' '}
                  </h4>
                )}
              <div className="plot-card__header">
                <ul className="plot-card__list">
                  {plotInfo?.bedrooms && <li>{plotInfo.bedrooms} Bed</li>}
                  {plotInfo?.garage_style && (
                    <li>{plotInfo.garage_style.label}</li>
                  )}
                  {plotInfo?.house_style && (
                    <li>{plotInfo.house_style.label}</li>
                  )}
                </ul>
              </div>
            </div>
            <div className="interactive-site-plan__bottom">
              {plotInfo?.link && plotInfo?.status != 'sold' && (
                <a
                  href={plotInfo.link}
                  className="button interactive-site-plan__button"
                >
                  View Home
                </a>
              )}
              <button
                className="button button--light interactive-site-plan__button"
                type="button"
                onClick={onInfoWindowClose}
              >
                Close
              </button>
            </div>
            {plotInfo?.feature && (
              <span
                className={`plot-card__feature plot-card__feature--${plotInfo.feature_color}`}
              >
                {plotInfo.feature}
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

const SitePlanApp = () => {
  ReactDOM.render(
    <InteractiveSitePlan />,
    document.getElementById('interactive-site-plan'),
  );
};

export default SitePlanApp;
